import { useCallback, useMemo, useState } from 'react';
import { PieChartData } from '../utils';

export const PageSize = 5;

type usePieChartDataPaginationReturnProps = {
  currentData: any[];
  currentPage: number;
  onNext: () => void;
  onPrevious: () => void;
  showPrev: boolean;
  showNext: boolean;
};

export const usePieChartDataPagination = (
  data: PieChartData,
  setGetCurrentPage?: React.Dispatch<React.SetStateAction<number>>
): usePieChartDataPaginationReturnProps => {
  const [currentPage, setCurrentPage] = useState(1);

  const currentData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return data.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, data]);

  const onNext = useCallback(() => {
    setCurrentPage((page) => page + 1);
    if (setGetCurrentPage) {
      setGetCurrentPage((page) => page + 1);
    }
  }, [setGetCurrentPage]);

  const onPrevious = useCallback(() => {
    setCurrentPage((page) => page - 1);
    if (setGetCurrentPage) {
      setGetCurrentPage((page) => page - 1);
    }
  }, [setGetCurrentPage]);
  return useMemo(() => {
    return {
      currentData,
      currentPage,
      onNext,
      onPrevious,
      showPrev: currentPage > 1,
      showNext: currentPage * PageSize < data.length
    };
  }, [currentData, currentPage, data.length, onNext, onPrevious]);
};
